import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { USER_LOCALSTORAGE_KEY } from '../../../../../../shared/const/localstorage';

interface ToggleAttendanceParams {
    user_id: number;
    value: boolean;
    lessonsId: string | undefined;
}

export interface ToggleAttendanceResponse {
    success: boolean;
    value: boolean;
}

export const toggleAttendance = createAsyncThunk<ToggleAttendanceResponse, ToggleAttendanceParams>(
    'attendance/toggle',
    async ({ user_id, value,lessonsId }: ToggleAttendanceParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);
            const response = await axios.post<ToggleAttendanceResponse>(
                `/api/lessons/${lessonsId}/toggle-attendance`,
                {
                    user_id: user_id,
                    value: value,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data) {
                return response.data;
            } else {
                throw new Error('Ошибка сети');
            }
        } catch (error) {
            return thunkAPI.rejectWithValue('error');
        }
    }
);